module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"labels":{"caseId":"Case ID","jobTitle":"Job title","email":"Email address","phone":"Phone"}}}')
  delete Component.options._Ctor
}
